import axios from "axios";
import { api } from "@/api";

const types = {
  SET_CITIES: "SET_CITIES",
  FETCH_FAILURE: "FETCH_FAILURE",
};

export const state = {
  cities: [],
};

export const mutations = {
  [types.SET_CITIES](state: any, data: any) {
    state.cities = data;
  },
};

export const actions = {
  async fetchCities({ commit }: any) {
    try {
      if (state.cities.length !== 0) {
        return;
      }
      const { data } = await axios.get(api.path("v2.cities"));
      commit(types.SET_CITIES, data.data);
    } catch (e) {
      commit(types.FETCH_FAILURE);
    }
  },

  async refreshCities({ commit }: any) {
    try {
      const { data } = await axios.get(api.path("v2.cities"));
      commit(types.SET_CITIES, data.data);
    } catch (e) {
      commit(types.FETCH_FAILURE);
    }
  },

  setCities({ commit }: any, payload: any) {
    commit(types.SET_CITIES, payload);
  },
};

export const getters = {
  cities: (state: any) => state.cities,
};
